import {
  Input,
  type GetProps,
  type GetRef,
  type InputProps,
  type InputRef,
} from 'antd';
import type { Ref } from 'react';

export type { InputProps, InputRef } from 'antd';

const AiInput = (props: InputProps & { ref?: Ref<InputRef> }) => (
  <Input placeholder="请输入" {...props} />
);

const AiTextArea = (
  props: GetProps<typeof Input.TextArea> & {
    ref?: Ref<GetRef<typeof Input.TextArea>>;
  },
) => <Input.TextArea placeholder="请输入" {...props} />;

AiInput.Search = Input.Search;
AiInput.Password = Input.Password;
AiInput.OTP = Input.OTP;
AiInput.TextArea = AiTextArea as typeof Input.TextArea;

export { AiInput as Input };
